var map = {
	"./Resource.NoTranslate.en-US.json": "./src/lang/locale/Resource.NoTranslate.en-US.json",
	"./Resource.NoTranslate.json": "./src/lang/locale/Resource.NoTranslate.json",
	"./Resource.en-US.json": "./src/lang/locale/Resource.en-US.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/lang/locale sync recursive \\bResource.\\b[\\bNoTranslate.\\b]*?[A-Za-z0-9-_,\\s]+\\b\\.json\\b$/";